<template>
  <page-layout
    title="基本信息"
    class="p-Information"
  >
    <div class="p-Information-pane">
      <div class="p-Information-pane-header clearfix">
        收件人信息
        <znl-button
          type="text"
          class="pull-right"
          @click="() => {openAddressEdit()}"
        >
          新增收货地址
        </znl-button>
      </div>
      <div>
        <el-row
          v-for="item in contacts"
          :key="item.UserContactId"
          class="address-row"
        >
          <span>{{item.UserContactName}}</span>
          <span>{{item.UserContactPhone}}</span>
          <span>{{item.ContactAddress}}</span>
          <span v-if="item.IsDefault">默认</span>

          <div class="pull-right btn-container">
            <znl-button
              type="text"
              @click="()=>{setDefaultAddress(item)}"
            >设为默认</znl-button>
            <znl-button
              type="text"
              @click="()=>{openAddressEdit(item)}"
            >修改</znl-button>
            <znl-button
              type="text"
              @click.stop="()=>{deleteAddress(item)}"
            >删除</znl-button>
          </div>
        </el-row>
      </div>
      <PickupAddress
        :visible.sync="showPickupAddress"
        :address="pickupAddress"
        :getUserContacts="getUserContacts"
      ></PickupAddress>
    </div>

    <div class="p-Information-pane">
      <div class="p-Information-pane-header clearfix">
        增值税专用发票信息
        <znl-button
          class="pull-right"
          type="text"
          @click="showInvoiceEdit=true"
          v-if="invoiceInfo"
        >
          修改
        </znl-button>
      </div>
      <div v-if="invoiceInfo">
        <el-row class="invoice-row">
          <label>单位名称:</label>
          <span>{{invoiceInfo ? invoiceInfo.InvoiceCompanyName : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>税务登记号:</label>
          <span>{{invoiceInfo ? invoiceInfo.InvoiceCode : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>注册地址:</label>
          <span>{{invoiceInfo ? invoiceInfo.CompanyAddress : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>注册电话:</label>
          <span>{{invoiceInfo ? invoiceInfo.CompanyMoblie : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>开户银行:</label>
          <span>{{invoiceInfo ? invoiceInfo.InvoiceOpenBank : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>银行账户:</label>
          <span>{{invoiceInfo ? invoiceInfo.InvoiceBankAccountNumber : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>收票人姓名:</label>
          <span>{{invoiceInfo ? invoiceInfo.CollectorName : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>电话号码:</label>
          <span>{{invoiceInfo ? invoiceInfo.CollectorMoblie : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>地址信息:</label>
          <span>{{invoiceInfo ? `${invoiceInfo. CollectorProvince}${invoiceInfo.CollectorCity}${invoiceInfo.CollectorCounty}` : ''}}</span>
        </el-row>

        <el-row class="invoice-row">
          <label>详细地址:</label>
          <span>{{invoiceInfo ? invoiceInfo.CollectorDetailed : ''}}</span>
        </el-row>
      </div>
      <div
        v-else
        class="no-invoice"
      >
        <znl-button
          style-type="main"
          :width="80"
          :height="30"
          @click="showInvoiceEdit=true"
        >新增发票信息</znl-button>
      </div>

      <InvoiceEdit
        :visible.sync="showInvoiceEdit"
        :invoiceInfo="invoiceInfo"
        :getInvoice="getInvoice"
      ></InvoiceEdit>
    </div>
  </page-layout>
</template>
<script>
import PageLayout from '../PageLayout';
import { httpPost, httpGet } from '../../assets/scripts/http';
import PickupAddress from './PickupAddress';
import InvoiceEdit from './InvoiceEdit';
export default {
  name: 'Information',
  components: { PageLayout, PickupAddress, InvoiceEdit },

  data() {
    return {
      contacts: [],
      invoiceInfo: null,
      pickupAddress: null,
      showPickupAddress: false,
      showInvoiceEdit: false
    };
  },
  methods: {
    // 获取联系人信息
    getUserContacts() {
      httpGet('bomorder/getUserContacts').then(res => {
        if (res.Code === 0) {
          this.contacts = res.Data;
        }
      });
    },
    // 获取发票信息
    getInvoice() {
      httpGet('bomorder/getInvoice').then(res => {
        if (res.Code === 0) {
          if (res.Data) {
            this.invoiceInfo = res.Data;
          } else {
            this.invoiceInfo = null;
          }
        } else {
          this.$BomMessage(res.Message);
        }
      });
    },
    // 打开地址编辑
    openAddressEdit(address) {
      this.pickupAddress = address ? address : null;
      this.showPickupAddress = true;
    },
    // 设置默认
    setDefaultAddress(address) {
      const addressInfo = Object.assign({}, address, { IsDefault: true });
      httpPost('bomorder/addUpdateUserContact', addressInfo).then(res => {
        if (res.Code === 0) {
          this.getUserContacts();
        } else {
          this.$BomMessage(res.Message);
        }
      });
    },
    // 删除地址
    deleteAddress(item) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          httpGet(`bomorder/deleteUserContact?id=${item.UserContactId}`).then(
            res => {
              if (res.Code === 0) {
                this.$succMess('删除成功');
                this.getUserContacts();
              } else {
                this.$erroMess(res.Message);
              }
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.getUserContacts();
    this.getInvoice();
  }
};
</script>
<style lang="scss">
.p-Information {
  .p-Information-pane {
    padding-left: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 2px 0px #ccc;
    font-size: 12px;
    background-color: #fff;
  }
  .p-Information-pane-header {
    font-size: 14px;
    color: #666;
    line-height: 50px;
  }

  .address-row {
    line-height: 40px;
    .btn-container {
      display: none;
    }
    &.active {
      background-color: #f2f2f2;
    }
    &:hover {
      .btn-container {
        display: block;
      }
    }
    span {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .invoice-row {
    line-height: 40px;
    label {
      width: 100px;
      display: inline-block;
      text-align: right;
      margin-right: 20px;
    }
  }

  .no-invoice {
    line-height: 100px;
    text-align: center;
  }
}
.ml10 {
  margin-left: 10px;
}
</style>
